import * as React from 'react'
import { cn } from '../../lib/utils'

export function ConflictColumnHead({
  children,
  selected,
  onSelect
}: {
  children: React.ReactNode
  selected?: boolean
  onSelect?: () => void
}) {
  const cls = cn(
    'pb-1 text-left text-10 font-medium tracking-wide uppercase',
    selected ? 'text-brand' : 'text-ink-3'
  )
  // When selectable, the column header sets the whole entity (the shortcut);
  // per-field picks live on the individual cells below.
  if (!onSelect) return <span className={cls}>{children}</span>
  return (
    <button
      type="button"
      onClick={onSelect}
      aria-pressed={selected}
      className={cn(cls, 'cursor-pointer rounded-sm hover:text-ink')}
    >
      {children}
    </button>
  )
}
